import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { AuthService } from '../../core/auth.service';

@Component({
  selector: 'app-reset-password-page',
  standalone: true,
  imports: [FormsModule, NgIf, RouterLink],
  templateUrl: './reset-password.page.html',
  styleUrl: './reset-password.page.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ResetPasswordPageComponent implements OnInit {
  token = '';
  password = '';
  confirmPassword = '';
  message = '';
  errorMessage = '';
  isLoading = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly authService: AuthService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.token = params.get('token') ?? '';
      this.cdr.markForCheck();
    });
  }

  submit(): void {
    if (!this.token) {
      this.errorMessage = 'Lien de réinitialisation invalide.';
      return;
    }
    if (!this.password || !this.confirmPassword) {
      this.errorMessage = 'Veuillez saisir votre nouveau mot de passe.';
      return;
    }
    if (this.password !== this.confirmPassword) {
      this.errorMessage = 'Les mots de passe ne correspondent pas.';
      return;
    }
    this.errorMessage = '';
    this.message = '';
    this.isLoading = true;
    this.authService.confirmPasswordReset(this.token, this.password).subscribe({
      next: () => {
        this.isLoading = false;
        this.message = 'Mot de passe mis à jour. Vous pouvez vous connecter.';
        this.cdr.markForCheck();
      },
      error: () => {
        this.isLoading = false;
        this.errorMessage = 'Le lien de réinitialisation est invalide ou expiré.';
        this.cdr.markForCheck();
      }
    });
  }
}
